import axios from 'axios'

//const BASE_URL = 'http://cerberusc.camtor.net:5005'
const BASE_URL = process.env.REACT_APP_SERVER_URL;
const axiosInstance = axios.create({
    baseURL: BASE_URL,
})

export async function crudReportesApi({ comando, token = '', data = null }) {

    //console.log('crudReportesApi: ', { comando, token, data });

    const headers = token ? { 'content-type': 'application/json', authorization: `Bearer ${token}` }
        : { 'content-type': 'application/json' }

    const body = { comando, token, data };

    try {
        const response = await axiosInstance.post('/rep/api', body, {   //devices api
            headers: headers
        })
        //console.log("response.data", response.data);
        return response.data;
    } catch (error) {
        //console.log(error);
        //console.log(error.response.data.message);
        throw new Error(error.response.data.message);
    }
}

